import { baseApi } from './baseApi';

const TAG = 'LaboratoryTests';

// eslint-disable-next-line no-unused-vars
const makeCompareQueries =
  (tag) =>
  async (id, { dispatch, queryFulfilled, getCacheEntry }) => {
    const entryData = getCacheEntry()?.data?.results || [];

    try {
      const { data } = await queryFulfilled;
      const { results } = data;

      const removedDocs = entryData.filter((oldDoc) => {
        return !results.find((newDoc) => newDoc.id === oldDoc.id);
      });

      if (removedDocs.length > 0) {
        const docTags = removedDocs.map(({ id }) => ({ type: TAG, id }));
        dispatch(baseApi.util.invalidateTags([TAG, ...docTags, tag]));
      }
    } catch (err) {
      // `onError` side-effect
      console.log('errrror', err);
    }
  };

const laboratoryTestsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchLaboratoryTestGroups: builder.query({
      query: ({ offset, limit, language }) => ({
        url: '/user-biomarkers/groups/',
        method: 'GET',
        params: { offset, limit, language },
      }),
      transformResponse: (response) => {
        if (!response || typeof response !== 'object') {
          return { results: [], count: 0, float_values: {}, string_values: {} };
        }

        const float_values = response.float_values || {};
        const string_values = response.string_values || {};

        // Combine float_values and string_values into a single results array
        const results = [
          ...Object.entries(float_values).map(([key, value]) => ({ key, value, type: 'float' })),
          ...Object.entries(string_values).map(([key, value]) => ({ key, value, type: 'string' })),
        ];
        const count = results.length;

        return {
          results,
          count,
          float_values,
          string_values,
        };
      },
      providesTags: [TAG],
      keepUnusedDataFor: 0,
    }),
    fetchLatestCategoryTest: builder.query({
      query: ({ icd9_code }) => ({
        url: '/user-biomarkers/latest_category_test/',
        method: 'GET',
        params: { icd9_code },
      }),
      transformResponse: (response) => {
        if (!response) {
          return {
            latest_date: null,
            days_since_last_test: null,
          };
        }
        return response;
      },
      providesTags: [TAG],
      keepUnusedDataFor: 0, // Disable caching
      refetchOnMountOrArgChange: true, // Force refetch on mount
    }),
  }),
});

// Helper function to create category test queries
export const createCategoryTestQueries = (codes) => {
  return codes.map((code) => ({
    queryKey: ['fetchLatestCategoryTest', { icd9_code: code }],
    queryFn: async () => {
      const response = await fetch(`/api/user-biomarkers/latest_category_test/?icd9_code=${code}`);
      if (!response.ok) {
        throw new Error('Failed to fetch category test data');
      }
      return response.json();
    },
  }));
};

export const { useFetchLaboratoryTestGroupsQuery, useFetchLatestCategoryTestQuery } =
  laboratoryTestsApi;
